// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
/**
 * Component capable of rendering the `Paywall's` contents.
 */
let PaywallModuleUi = class PaywallModuleUi extends AbstractModuleUi {
};
PaywallModuleUi = __decorate([
    Component({
        name: 'AdBannerModuleUi',
        template: '<span class="paywall"></span>'
    })
], PaywallModuleUi);
export { PaywallModuleUi };
